import { render } from "./Header.vue?vue&type=template&id=4acf4a0c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4acf4a0c&scoped=true&lang=css"
import "./Header.vue?vue&type=style&index=1&id=4acf4a0c&lang=css"

import exportComponent from "D:\\corpsbattle\\cb-web\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acf4a0c"]])

export default __exports__